/* Compliance feature flags.
 *
 * FINANCE_MITRA_ENABLED — controls the public visibility of every
 * finance / home-loan / EMI / banking-coordination surface across the
 * site. While false, the Razorpay merchant remains positioned strictly
 * as an architectural design marketplace.
 *
 * Set via build-time env: REACT_APP_FINANCE_MITRA_ENABLED=true to turn
 * it back on without code changes. Defaults to FALSE.
 *
 * IMPORTANT: code, copy, and DB records remain intact — this flag only
 * gates rendering. Restoration is a single flip + redeploy away.
 */
export const FINANCE_MITRA_ENABLED =
  (process.env.REACT_APP_FINANCE_MITRA_ENABLED || "false").toLowerCase() === "true";
